import React, { useState } from "react";
import styles from "./Login.module.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Logo-nero 1.svg";
import LoginForm from "./components/LoginForm";
import RegistrationForm from "./components/RegistrationForm";
import Confirm from "./components/Confirm";

const Login = () => {
  const navigate = useNavigate();
  const [formName, setFormName] = useState("login");
  const [confirmButtonClicked, setConfirmButtonClicked] = useState(false);
  //
  return (
    <GoogleOAuthProvider clientId="701935159046-o7gvl5k4emss78j9m3db84vs6l9l4grj.apps.googleusercontent.com">
      <div>
        <div className={styles["container"]}>
          <div className={styles["inner-container"]}>
            <div className={styles["heading-container"]}>
              <LiaAngleLeftSolid
                size={22}
                strokeWidth={1.5}
                style={{ cursor: "pointer", marginRight: "5px" }}
                onClick={() => navigate("/")}
              />
              <p className={styles["heading-main"]}>torna indietro</p>
            </div>
          </div>
          {!confirmButtonClicked && (
            <div className={styles["login-registration-container"]}>
              <p
                className={styles["login-button"]}
                isactive={formName === "login" ? "yes" : "no"}
                onClick={() => setFormName("login")}
              >
                Accedi
              </p>
              <div className={styles["seprator"]} />
              <p
                className={styles["registration-button"]}
                isactive={formName === "registration" ? "yes" : "no"}
                onClick={() => setFormName("registration")}
              >
                Registrati
              </p>
            </div>
          )}
          {formName === "login" && !confirmButtonClicked && (
            <LoginForm setConfirmButtonClicked={setConfirmButtonClicked} />
          )}
          {formName === "registration" && !confirmButtonClicked && (
            <RegistrationForm
              setConfirmButtonClicked={setConfirmButtonClicked}
            />
          )}
          {confirmButtonClicked && (
            <Confirm
              setConfirmButtonClicked={confirmButtonClicked}
              formName={formName}
            />
          )}
        </div>
        <div className={styles["footer"]}>
          <div className={styles["exagon-logo-text"]}>Powered by</div>
          <img className={styles["exagon-logo"]} src={logo} alt="" />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
